import { createContext, useContext, useEffect, useState } from 'react';

const dictionaries = {
  es: {
    // General
    app_name: 'EZ DockIT',
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
    email: 'Email',
    password: 'Contraseña',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Crear',
    search: 'Buscar',
    loading: 'Cargando...',
    yes: 'Sí',
    no: 'No',
    // Nav
    nav_quick_receipt: 'Nueva factura',
    nav_dashboard: 'Panel',
    nav_clients: 'Clientes',
    nav_receipts: 'Facturas',
    nav_payment_receipts: 'Recibos',
    nav_reports: 'Reportes',
    nav_services: 'Servicios',
    nav_users: 'Usuarios',
    nav_settings: 'Configuración',
    nav_audit: 'Auditoría',
    // Login
    login_title: 'Acceder a su cuenta',
    login_subtitle: 'Sistema de facturación para bufete legal',
    login_button: 'Iniciar sesión',
    login_error: 'Credenciales incorrectas',
    // Quick receipt (now: Nueva Factura)
    qr_title: 'Nueva factura',
    qr_step_client: 'Cliente',
    qr_step_services: 'Servicios',
    qr_step_payment: 'Método de pago',
    qr_step_generate: 'Generar',
    qr_next: 'Siguiente',
    qr_back: 'Atrás',
    qr_generate: 'Generar factura',
    // Reminders
    reminder_label: 'Recordatorios automáticos',
    reminder_help: 'Se enviarán al cliente por email hasta que la factura sea pagada',
    reminder_none: 'Sin recordatorios',
    reminder_daily: 'Diario',
    reminder_weekly: 'Semanal',
    reminder_biweekly: 'Cada 2 semanas',
    reminder_monthly: 'Mensual',
    // Clients
    clients_new: 'Nuevo cliente',
    client_full_name: 'Nombre completo',
    client_phone: 'Teléfono',
    client_address: 'Dirección',
    client_matter: 'Matter/Caso #',
    client_case: 'Nombre del caso',
    client_notes: 'Notas internas',
    // Services
    service_name: 'Nombre',
    service_category: 'Categoría',
    service_price: 'Precio',
    service_description: 'Descripción',
    service_taxable: 'Con impuesto',
    service_active: 'Activo',
    // Payment
    pay_stripe: 'Pagar con tarjeta (Stripe)',
    pay_ath: 'Pagar con ATH Móvil',
    pay_cash: 'Efectivo',
    pay_check: 'Cheque',
    pay_bank: 'Transferencia',
    pay_link: 'Enviar link de pago',
    pay_manual: 'Pago manual',
    // Receipt
    receipt_number: 'Número',
    receipt_date: 'Fecha',
    receipt_client: 'Cliente',
    receipt_status: 'Estado',
    receipt_total: 'Total',
    receipt_method: 'Método',
    receipt_print: 'Imprimir',
    receipt_download_pdf: 'Descargar PDF',
    receipt_email: 'Enviar por email',
    // Statuses
    status_paid: 'Pagado',
    status_pending: 'Pendiente',
    status_voided: 'Anulado',
    status_refunded: 'Reembolsado',
    status_partially_refunded: 'Reembolso parcial',
    status_manual_verification_pending: 'Verificación manual',
    status_failed: 'Fallido',
    status_canceled: 'Cancelado',
    status_draft: 'Borrador',
    // Dashboard
    dash_today: 'Cobrado hoy',
    dash_week: 'Esta semana',
    dash_month: 'Este mes',
    dash_all_time: 'Total histórico',
    dash_recent: 'Pagos recientes',
    dash_by_method: 'Por método',
    dash_avg: 'Promedio',
    dash_net: 'Neto',
    dash_refunds: 'Reembolsos',
  },
  en: {
    app_name: 'EZ DockIT',
    login: 'Sign in',
    logout: 'Sign out',
    email: 'Email',
    password: 'Password',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    loading: 'Loading...',
    yes: 'Yes',
    no: 'No',
    nav_quick_receipt: 'New invoice',
    nav_dashboard: 'Dashboard',
    nav_clients: 'Clients',
    nav_receipts: 'Invoices',
    nav_payment_receipts: 'Receipts',
    nav_reports: 'Reports',
    nav_services: 'Services',
    nav_users: 'Users',
    nav_settings: 'Settings',
    nav_audit: 'Audit',
    login_title: 'Sign in to your account',
    login_subtitle: 'Billing system for law firm',
    login_button: 'Sign in',
    login_error: 'Invalid credentials',
    qr_title: 'New invoice',
    qr_step_client: 'Client',
    qr_step_services: 'Services',
    qr_step_payment: 'Payment method',
    qr_step_generate: 'Generate',
    qr_next: 'Next',
    qr_back: 'Back',
    qr_generate: 'Generate invoice',
    reminder_label: 'Automatic reminders',
    reminder_help: 'Will be emailed to the client until the invoice is paid in full',
    reminder_none: 'No reminders',
    reminder_daily: 'Daily',
    reminder_weekly: 'Weekly',
    reminder_biweekly: 'Every 2 weeks',
    reminder_monthly: 'Monthly',
    clients_new: 'New client',
    client_full_name: 'Full name',
    client_phone: 'Phone',
    client_address: 'Address',
    client_matter: 'Matter/Case #',
    client_case: 'Case name',
    client_notes: 'Internal notes',
    service_name: 'Name',
    service_category: 'Category',
    service_price: 'Price',
    service_description: 'Description',
    service_taxable: 'Taxable',
    service_active: 'Active',
    pay_stripe: 'Pay by card (Stripe)',
    pay_ath: 'Pay with ATH Móvil',
    pay_cash: 'Cash',
    pay_check: 'Check',
    pay_bank: 'Bank transfer',
    pay_link: 'Send payment link',
    pay_manual: 'Manual payment',
    receipt_number: 'Number',
    receipt_date: 'Date',
    receipt_client: 'Client',
    receipt_status: 'Status',
    receipt_total: 'Total',
    receipt_method: 'Method',
    receipt_print: 'Print',
    receipt_download_pdf: 'Download PDF',
    receipt_email: 'Send by email',
    status_paid: 'Paid',
    status_pending: 'Pending',
    status_voided: 'Voided',
    status_refunded: 'Refunded',
    status_partially_refunded: 'Partially refunded',
    status_manual_verification_pending: 'Manual verification',
    status_failed: 'Failed',
    status_canceled: 'Canceled',
    status_draft: 'Draft',
    dash_today: 'Today',
    dash_week: 'This week',
    dash_month: 'This month',
    dash_all_time: 'All-time',
    dash_recent: 'Recent payments',
    dash_by_method: 'By method',
    dash_avg: 'Average',
    dash_net: 'Net',
    dash_refunds: 'Refunds',
  },
};

const I18nContext = createContext({ t: (k) => k, lang: 'es', setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem('firmpay_lang') || 'es');
  const setLang = (l) => { localStorage.setItem('firmpay_lang', l); setLangState(l); document.documentElement.lang = l; };
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  const t = (k) => dictionaries[lang]?.[k] ?? dictionaries.es[k] ?? k;
  return <I18nContext.Provider value={{ t, lang, setLang }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
